module.exports = __webpack_public_path__ + "img/10.457896a4.png";